const styles = {
  root: {
    maxWidth: 860,
    marginTop: '3%',
    margin: 'auto',
    width: '80‰',
    textAlign: 'center'

  },
  Button: {
    marginTop: 10,
    marginRight: 110
  },
  delete: {
    textAlign: 'right'
  }
}

export default styles
